export default __webpack_public_path__ + "static/media/dog_v2.57a6b764.png";